import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Reusable badge component for Academy UI
 * Displays badges like: "3 lessons", "Beginner", "24 min", "New", "Updated"
 *
 * Usage:
 * <ut-academy-badge type="lessons" [value]="3"></ut-academy-badge>
 * <ut-academy-badge type="difficulty" value="Beginner"></ut-academy-badge>
 * <ut-academy-badge type="time" [value]="24"></ut-academy-badge>
 * <ut-academy-badge type="new"></ut-academy-badge>
 */
@Component({
  selector: 'ut-academy-badge',
  templateUrl: './academy-badge.component.html',
  styleUrls: ['./academy-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AcademyBadgeComponent {
  @Input() type: 'lessons' | 'time' | 'difficulty' | 'new' | 'updated' | 'progress' | 'failed' = 'lessons';
  @Input() value?: string | number;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  get displayText(): string {
    switch (this.type) {
      case 'lessons':
        return `${this.value} lesson${this.value === 1 ? '' : 's'}`;
      case 'time':
        return `${this.value} min`;
      case 'difficulty':
        return String(this.value || 'Beginner');
      case 'new':
        return 'New';
      case 'updated':
        return 'Updated';
      case 'progress':
        return `${this.value}%`;
      case 'failed':
        return 'Failed';
      default:
        return String(this.value || '');
    }
  }

  get cssClass(): string {
    let classes = `badge-${this.type} badge-${this.size}`;

    if (this.type === 'difficulty' && this.value) {
      classes += ` badge-difficulty-${String(this.value).toLowerCase()}`;
    }

    return classes;
  }
}
